// FETCH KB HUB FAILURE
export const FETCH_KB_HUB_FAILURE =
	'state.actions.fetch-knowledge-hub-failure.FETCH_KB_HUB_FAILURE' as const;

export type FetchKbHubFailurePayload = {
	error: {
		message: string;
		key: string;
	};
};

export type FetchKbHubFailureAction = {
	type: typeof FETCH_KB_HUB_FAILURE;
	payload: FetchKbHubFailurePayload;
};

export const fetchKbHubFailure = (payload: FetchKbHubFailurePayload): FetchKbHubFailureAction => ({
	type: FETCH_KB_HUB_FAILURE,
	payload,
});
